import { Component, OnInit } from '@angular/core';
import { CourseService } from 'src/app/services/course.service';
import { iHttpPaginatedResponse } from 'src/app/interfaces/iHttpPaginatedResponse';
import { Published } from '../../pipes/published.pipe';
import { Course } from 'src/app/models/course';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { FilterOption } from 'src/app/models/filter-option';
import { VimeoService } from 'src/app/services/vimeo.service';

@Component({
  selector: 'app-courses',
  templateUrl: './courses.component.html',
  styleUrls: ['./courses.component.scss']
})
export class CoursesComponent implements OnInit {
  private perPage=20;
  public loadingCourses: boolean = true;
  public paginatedCourses = new BehaviorSubject<any>(null);
  public availableFilters=[];
  private filterString='filter[published]';

  constructor(
    private courseService: CourseService,
    private router: Router,
    private vimeoService: VimeoService
    ) {
      this.availableFilters.push(new FilterOption({name:'title',type:'string'}));
      this.availableFilters.push(new FilterOption({
        name:'published',
        type:'select',
        'options':[
          {name:'Any',value:''},
          {name:'Yes',value:1},
          {name:'No', value:0}
        ],
        default: ''
      }));
      // this.availableFilters.push(new FilterOption({
      //   name:'deleted',
      //   type:'select',
      //   'options':[
      //     {name:'Any',value:''},
      //     {name:'Yes',value:1},
      //     {name:'No', value:0}
      //   ],
      //   default: 0
      // }));
    }

  ngOnInit() {
    this.getCourses(1);
  }

  public getCourses(page){
    this.courseService.getCourses(page,this.perPage,'-created_at','','include=lessons&'+this.filterString).subscribe(paginatedData=>{
      this.paginatedCourses.next(paginatedData);
      this.loadingCourses = false;
    })
  }

  public addNewCourse(){
    if(confirm('Confirm you want to add a new course?')){
      this.courseService.createCourse().subscribe((res:Course) => {
        this.router.navigate([`/course/${res.id}`]);
      });
    }
  }

  public updateLessonThumbnails(){
    if(confirm('Are you sure you want to do this, it is a mighty intensive and lengthy process!')){
      this.vimeoService.massUpdateThumbnails().subscribe(
        res => {
          console.log(res);
        }
      );
    }
  }

  pageChanged(data){
    this.perPage=data.pageSize;
    this.getCourses(data.pageIndex+1);
  }

  perPageChanged(data){
    this.perPage=data.pageSize;
    this.getCourses(1);
  }

  filterChanged(filters){
    this.filterString = filters;
    this.getCourses(1);
  }

  public goToCourse(course: Course){
    this.router.navigate([`/course/${course.id}`]);
  }

}
